import AboutMastersWidget from "@/widgets/AboutMastersWidget/index.jsx";

export default function AboutMastersPage() {
    return (
        <AboutMastersWidget />
    )
}